export const UZBEKISTAN_COUNTRY_CODE = "998";
export const LOCAL_PHONE_LENGTH = 9;
export const MAX_PHONE_DIGITS = UZBEKISTAN_COUNTRY_CODE.length + LOCAL_PHONE_LENGTH;
export const PHONE_REGEX = /^998\d{9}$/;

export function extractPhoneDigits(value: string) {
  return value.replace(/\D/g, "").slice(0, MAX_PHONE_DIGITS);
}

export function normalizePhoneForSubmit(value: string) {
  const digits = extractPhoneDigits(value);

  if (digits.startsWith(UZBEKISTAN_COUNTRY_CODE)) {
    return digits;
  }

  return `${UZBEKISTAN_COUNTRY_CODE}${digits.slice(0, LOCAL_PHONE_LENGTH)}`;
}

export function isValidPhone(value: string) {
  return PHONE_REGEX.test(normalizePhoneForSubmit(value));
}

export function extractLocalDigits(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (digits.startsWith(UZBEKISTAN_COUNTRY_CODE)) {
    return digits.slice(UZBEKISTAN_COUNTRY_CODE.length, UZBEKISTAN_COUNTRY_CODE.length + LOCAL_PHONE_LENGTH);
  }
  return digits.slice(0, LOCAL_PHONE_LENGTH);
}

export function formatPhoneInput(value: string) {
  const digits = extractPhoneDigits(value);
  if (!digits) {
    return "";
  }

  const localDigits = digits.startsWith(UZBEKISTAN_COUNTRY_CODE)
    ? digits.slice(UZBEKISTAN_COUNTRY_CODE.length)
    : digits;

  const limitedLocalDigits = localDigits.slice(0, LOCAL_PHONE_LENGTH);
  const parts: string[] = [];

  if (limitedLocalDigits.slice(0, 2)) {
    parts.push(limitedLocalDigits.slice(0, 2));
  }
  if (limitedLocalDigits.slice(2, 5)) {
    parts.push(limitedLocalDigits.slice(2, 5));
  }
  if (limitedLocalDigits.slice(5, 7)) {
    parts.push(limitedLocalDigits.slice(5, 7));
  }
  if (limitedLocalDigits.slice(7, 9)) {
    parts.push(limitedLocalDigits.slice(7, 9));
  }

  return `+998 ${parts.join(" ")}`.trim();
}
